export class CustomerInstanceGroupData {
    id: string;
    groupId: string;
}

export class CustomerInstanceGroupSalesData {
    salesTotalLastPeriod: number;
}

